<template>
  <div class="home">
    <!-- 轮播图 -->
    <section class="hero">
      <el-carousel height="600px" :interval="5000" arrow="always">
        <el-carousel-item v-for="(item, index) in carouselItems" :key="index">
          <div class="carousel-content" :style="{ backgroundImage: `url(${item.image})` }">
            <div :class="item.container">
              <div class="content">
                <h1>{{ item.title }}</h1>
                <p>{{ item.description }}</p>
                <el-button type="primary" size="large" @click="item.action">{{ item.buttonText }}</el-button>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- 核心优势 -->
    <section class="advantages">
      <div class="container">
        <h2 class="section-title">核心优势</h2>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="6" v-for="(advantage, index) in advantages" :key="index">
            <div class="advantage-card">
              <img :src="advantage.image" :alt="advantage.title" class="advantage-image">
              <h3>{{ advantage.title }}</h3>
              <p class="description">{{ advantage.description }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <section class="our-value">
      <div class="container">
        <h2 class="section-title">我们的价值</h2>
        <div class="step-advantage-section">
          <div class="step-container">
            <!-- 卡片从低到高排列 -->
            <div 
              class="step-card" 
              v-for="(item, index) in advantageList" 
              :key="index"
              :style="{
                top: (advantageList.length - index - 1) * 30 + 'px',
                left: index * 300 + 'px'
              }"
            >
              <div class="icon-box">
                <img :src="item.icon" alt="icon" class="icon">
              </div>
              <h3 class="title">{{ item.title }}</h3>
              <p class="desc">{{ item.desc }}</p>
            </div>
            <!-- 连线 -->
            <div class="wave-line" 
              :style="{
                // 根据卡片数量动态调整宽度，让波浪线覆盖卡片间距
                width: '80%',
                // 调整 top 值让波浪线垂直位置适配卡片
                top: '-42px' 
              }">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据统计 -->
    <section class="stats-section">
      <div class="container">
        <h2 class="section-title">企业实力</h2>
        <div class="stats-grid" itemscope itemtype="https://schema.org/Organization">
          <div class="stat-card">
            <div class="stat-icon">
              <img src="@/assets/images/hezuo.png" alt="合作企业" class="stat-img">
            </div>
            <div class="stat-content" itemprop="hasOfferCatalog" itemscope itemtype="https://schema.org/OfferCatalog">
              <div class="stat-number" itemprop="name">10,000+</div>
              <div class="stat-label" itemprop="description">服务超过10000+不同行业的客户</div>
              <meta itemprop="numberOfItems" content="10000">
            </div>
          </div>
          <div class="stat-card">
            <div class="stat-icon">
              <img src="@/assets/images/huoyue.png" alt="活跃卡数" class="stat-img">
            </div>
            <div class="stat-content" itemscope itemprop="makesOffer" itemtype="https://schema.org/Offer">
              <div class="stat-number" itemprop="name">5000万</div>
              <div class="stat-label" itemprop="description">平台在线激活设备超过5000万个</div>
              <meta itemprop="quantity" content="50000000">
            </div>
          </div>
          <div class="stat-card">
            <div class="stat-icon">
              <img src="@/assets/images/international.png" alt="全球覆盖" class="stat-img">
            </div>
            <div class="stat-content" itemprop="areaServed" itemscope itemtype="https://schema.org/Place">
              <div class="stat-number" itemprop="name">200+</div>
              <div class="stat-label" itemprop="description">覆盖200+个国家和地区</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 解决方案 -->
    <section class="solutions">
      <div class="container">
        <h2 class="section-title">应用场景</h2>
        <el-row :gutter="20" class="scene-grid">
          <el-col :xs="24" :sm="12" :md="8" v-for="(item, index) in sceneList" :key="index">
            <!-- 核心：使用 el-card 结合相对定位实现内容切换 -->
            <el-card class="scene-card" shadow="hover">
              <div class="card-content">
                <!-- 图片层 -->
                <div class="card-image">
                  <img :src="item.image" :alt="item.title" class="scene-img">
                  <div class="image-overlay"></div>
                </div>
                
                <!-- 内容层 -->
                <div class="card-info">
                  <h3>{{ item.title }}</h3>
                  <p class="desc-text">{{ item.desc }}</p>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 合作伙伴 -->
    <section class="partners">
      <div class="container">
        <h2 class="section-title">合作伙伴</h2>
        <el-row :gutter="20" type="flex" justify="center">
          <el-col :xs="12" :sm="8" :md="8" v-for="(partner, index) in partners" :key="index">
            <div class="partner-logo">
              <img :src="partner.logo" :alt="partner.name">
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      carouselItems: [
        {
          image: require('@/assets/images/home/banner_a.jpg'),
          title: '物联网设备专用流量卡',
          description: '多家运营商 快速对接 安全稳定 智慧运营',
          buttonText: '了解更多',
          container:'container',
          action: () => this.$router.push('/solutions')
        },
        {
          image: require('@/assets/images/home/banner_b.jpg'),
          title: '桔子智联物联网卡云平台',
          description: '渠道商多级分销管理 持续分润',
          buttonText: '立即体验',
          container:'container right',
          action: () => window.location.href = 'https://iot.juzi1688.cn/'
        },
        {
          image: require('@/assets/images/home/banner_c.jpg'),
          title: '赋能企业成为物联网运营服务商',
          description: '整合资源,深度垂直,提供物联网智慧运营服务方案',
          buttonText: '了解更多',
          container:'container center',
          action: () => this.$router.push('/contact')
        }
      ],
      advantages: [
        {
          image: require('@/assets/images/advantages/a.png'),
          title: '三网合一',
          description: '中国移动/电信/联通三家运营商\n物联网卡套餐按需设置\n大行业客户可组建流量池'
        },
        {
          image: require('@/assets/images/advantages/b.png'),
          title: '物联网云平台',
          description: '强大的流量卡云平台管理功能\n方便查询卡状态、流量、提醒，确保通讯稳定\n开放营帐系统，清楚名下客户充值分润情况'
        },
        {
          image: require('@/assets/images/advantages/c.png'),
          title: '平台接入',
          description: '提供API（应用程序接口）接口\n方便企业集成到自己的物联网设备管理平台'
        },
        {
          image: require('@/assets/images/advantages/d.png'),
          title: '一对一服务',
          description: '拥有多员通信级技术服务人员\n专业营销顾问7*24小时为您提供服务'
        }
      ],
      advantageList: [
        {
          title: '专业的管理平台',
          desc: '多网统一,运营商源头卡\n直连专用物联网通道\n选网、计费灵活\n信息查询和流量池预警',
          icon: require('@/assets/images/service/a.png')
        },
        {
          title: '资源优势',
          desc: '直签、授权物联网卡服务商\n卡源安全、供货能力稳定\n移动/联通/电信/\n全周期各种卡型',
          icon: require('@/assets/images/service/b.png')
        },
        {
          title: '资金保障',
          desc: '向运营商缴纳保证金\n用户充值安全\n安全的品质保障\n持久稳定的保障',
          icon: require('@/assets/images/service/c.png')
        },
        {
          title: '售后服务保障',
          desc: '平台采用BI商业智能技术\n可查询状态流量使用情况\n自行选择套餐充值\n系统自动停卡或复卡',
          icon: require('@/assets/images/service/d.png')
        }
      ],
      sceneList: [
        {
          image: require('@/assets/images/scence/01.jpg'),
          title: '安防监控',
          desc: '森林防火 防盗伐监控\n各种无有线网络场景的监控',
          hover: false
        },
        {
          image: require('@/assets/images/scence/02.jpg'),
          title: '移动传媒',
          desc: '电梯广告机  户外广告机\n大巴公交车移动电视等',
          hover: false
        },
        {
          image: require('@/assets/images/scence/03.jpg'),
          title: '共享经济模式',
          desc: '共享单车  电动自行车\n共享音乐吧  共享理发室',
          hover: false
        },
        {
          image: require('@/assets/images/scence/04.jpg'),
          title: '工业物联网',
          desc: '联网电梯  数控机床  锅炉监控\n工程机械等   室外采矿作业等',
          hover: false
        },
        {
          image: require('@/assets/images/scence/05.jpg'),
          title: '智慧交通',
          desc: '无人驾驶 车辆前装 轨道交通\n运营车 特种车 互联网+公务车',
          hover: false
        },
        {
          image: require('@/assets/images/scence/06.jpg'),
          title: '智慧城市',
          desc: '路灯监控  安防监控  井盖监控\n消防栓监控  水质监测  大气监测',
          hover: false
        },
        {
          image: require('@/assets/images/scence/07.jpg'),
          title: '智慧能源',
          desc: '可远程抄表的水/电/气/热表具\n光伏发电  充电桩',
          hover: false
        },
        {
          image: require('@/assets/images/scence/08.jpg'),
          title: '智慧物流',
          desc: '货物跟踪  智能快递柜\nRFID扫码枪',
          hover: false
        },
        {
          image: require('@/assets/images/scence/09.jpg'),
          title: '智能家居',
          desc: '智能门锁\n可穿戴设备',
          hover: false
        },
        {
          image: require('@/assets/images/scence/10.jpg'),
          title: '智慧农业',
          desc: '农业机械  智慧大棚\n智慧养殖  智慧种植',
          hover: false
        },
        {
          image: require('@/assets/images/scence/11.jpg'),
          title: '应急救援',
          desc: '自然灾害\n火灾救援',
          hover: false
        },
        {
          image: require('@/assets/images/scence/12.png'),
          title: '消费电子',
          desc: '4G/5G无线路由器  4G/5G电视机顶盒...',
          hover: false
        },
        // 其他场景数据...
      ],
      solutions: [
        {
          title: '工业物联网',
          description: '实现工厂智能化改造，提升生产效率',
          image: require('@/assets/images/industrial.jpg'),
          route: '/solutions/industrial'
        },
        {
          title: '智慧城市',
          description: '构建智能化城市管理系统',
          image: require('@/assets/images/smart-city.jpg'),
          route: '/solutions/smart-city'
        },
        {
          title: '智慧农业',
          description: '打造现代化农业生产系统',
          image: require('@/assets/images/agriculture.jpg'),
          route: '/solutions/agriculture'
        }
      ],
      partners: [
        { name: '中国移动', logo: require('@/assets/images/home/unicom.jpg') },
        { name: '中国电信', logo: require('@/assets/images/home/dianxin.jpg') },
        { name: '中国联通', logo: require('@/assets/images/home/unicom.jpg') },
        { name: '国际', logo: require('@/assets/images/home/international.png') }
      ]
    }
  },
  computed: {
    structuredData() {
      return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "桔子智联",
        "description": "物联网设备专用流量卡服务商，提供三网合一物联网卡、物联网云平台、API接口接入服务，覆盖200+国家和地区",
        "url": "https://iot.juzi1688.cn/",
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "物联网卡服务",
          "description": "服务超过10000+不同行业的客户，平台在线激活设备超过5000万个，覆盖200+国家和地区"
        },
        "areaServed": {
          "@type": "Place",
          "name": "全球200+国家和地区"
        },
        "makesOffer": {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "物联网卡服务",
            "description": "物联网设备专用流量卡，包含三网合一套餐、流量池管理、设备状态查询，覆盖200+国家和地区",
            "provider": {
              "@type": "Organization",
              "name": "桔子智联"
            }
          }
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "10000"
        }
      })
    }
  },
  methods: {
    goToSolution(route) {
      this.$router.push(route)
    }
  },
  mounted() {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = this.structuredData;
    document.head.appendChild(script);
  }
}
</script>

<style lang="scss" scoped>
.home {
  .stats-section {
    padding: 60px 0;
    background: #f8f9fa;
    
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
    }
    
    .stats-grid {
      display: flex;
      justify-content: space-between;
      gap: 30px;
    }
    
    .stat-card {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      padding: 40px 30px;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.08);
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(64, 158, 255, 0.2);
      }
      
      .stat-icon {
        width: 85px;
        height: 85px;
        min-width: 85px;
        min-height: 85px;
        flex-shrink: 0;
        background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 30px;
        box-shadow: 0 4px 15px rgba(30, 58, 95, 0.4);
        overflow: hidden;
        
        i {
          font-size: 36px;
          color: #fff;
        }
        
        .stat-img {
          width: 60%;
          height: 60%;
          object-fit: contain;
          filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
        }
      }
      
      .stat-content {
        text-align: left;
        
        .stat-number {
          font-size: 52px;
          font-weight: 700;
          color: #409eff;
          margin-bottom: 8px;
        }
        
        .stat-label {
          font-size: 22px;
          font-weight: 600;
          color: #2c3e50;
        }
      }
    }
  }
  
  .hero {
    margin-top: 60px;
    
    .carousel-content {
      height: 100%;
      background-size: cover;
      background-position: center;
      display: flex;
      align-items: center;
      color: #fff;
      
      .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;

        &.right{
          display: flex;
          flex-direction: column;
          align-items: flex-end;          
        }
        &.center{
          text-align: center;
        }
        
        h1 {
          font-size: 48px;
          margin-bottom: 20px;
        }
        
        p {
          font-size: 24px;
          margin-bottom: 30px;
        }
      }
    }
  }
  
  .section-title {
    text-align: center;
    font-size: 36px;
    margin-bottom: 50px;
    color: #2c3e50;
  }
  
  .advantages {
    padding: 80px 0;
    background: #f8f9fa;
    
    .advantage-card {
      height: 300px;
      text-align: center;
      padding: 30px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 20px;
      font-size: 0.875rem;
      .description{
        color: #666;
        line-height: 1.6;
        // 保留空白符序列，正常进行换行
        white-space: pre-wrap; 
      }
      i {
        font-size: 48px;
        color: #409EFF;
        margin-bottom: 20px;
      }
      
      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #2c3e50;
      }
      
      p {
        color: #666;
        line-height: 1.6;
      }
    }
  }

  .step-advantage-section {
      position: relative;
      min-height: 360px;
      background-color: #fff;
      padding: 80px 0px 20px 0px;
      overflow: hidden;
    }

    .step-container {
      position: relative;
    }

    .step-card {
      position: absolute;
      width: 200px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
      padding: 20px;
      text-align: center;
      transition: all 0.3s ease;
      z-index: 99999;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      }

      .icon-box {
        width: 60px;
        height: 60px;
        margin: 0 auto 10px;

        .icon {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
      }

      .desc {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
        white-space: pre - line;
      }
    }

    .line {
      position: absolute;
      height: 2px;
      background-color: #409eff;
      transition: all 0.3s ease;
    }
    .wave-line {
      position: absolute;
      left: 90px; // 从左侧开始
      height: 135px; // 波浪线图片的大致高度，可调整
      background: url('../assets/images/service/line.png') no-repeat; 
      // 替换为你实际的波浪线图片地址，这里用了占位示例
      background-size: 100% 100%; 
      // 让背景图片水平重复，垂直方向适配容器高度
    }
  
  .solutions {
    // padding: 80px 0;
    .scene-grid {
      max-width: 1200px;
      margin: 0 auto;
    }
    ::v-deep .el-card__body{
      padding: 0px;
    }

    .scene-card {
      // height: 280px;
      padding: 0 !important;
      overflow: hidden;
      position: relative;

      .card-content {
        width: 100%;
        height: 100%;
        position: relative;
      }

      .card-image {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        transition: opacity 0.3s ease; // 添加透明度过渡效果
        
        .scene-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.2);
          opacity: 0;
          transition: opacity 0.3s ease;
        }
      }

      .card-info {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: #409eff;
        color: #fff;
        opacity: 0; // 初始透明度为 0，隐藏内容
        transition: opacity 0.3s ease; // 添加透明度过渡效果
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        .desc-text {
          font-size: 1rem;
          line-height: 1.6;
          margin-bottom: 20px;
          // 保留空白符序列，正常进行换行
          white-space: pre-wrap; 
        }

        h3 {
          font-size: 18px;
          margin-bottom: 15px;
        }
        
        p {
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 20px;
        }
        
        .el-button {
          background: #fff;
          color: #409eff;
          border: none;
        }
      }

      // 悬浮时的样式变化
      &:hover {
        .card-image {
          opacity: 0; // 悬停时图片透明度为 0，隐藏图片
        }
        .card-info {
          opacity: 1; // 悬停时内容透明度为 1，显示内容
        }
      }
    }
  }
  
  .partners {
    padding: 80px 0;
    background: #f8f9fa;
    
    .partner-logo {
      padding: 20px;
      // background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 20px;
      
      img {
        width: 100%;
        height: auto;
        // filter: grayscale(100%);
        transition: filter 0.3s;
        height: 160px;
      }
      
      &:hover img {
        filter: grayscale(0%);
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .home {
    .stats-section {
      padding: 40px 0;
      
      .stats-grid {
        flex-direction: column;
        gap: 20px;
      }
      
      .stat-card {
        padding: 20px;
        
        .stat-icon {
          width: 50px;
          height: 50px;
          margin-right: 15px;
          
          i {
            font-size: 24px;
          }
        }
        
        .stat-content {
          .stat-number {
            font-size: 32px;
          }
          
          .stat-label {
            font-size: 16px;
          }
        }
      }
    }
    
    .hero {
      margin-top: 50px;
      
      .carousel-content {
        .container {
          h1 {
            font-size: 32px;
          }
          
          p {
            font-size: 18px;
          }
        }
      }
    }
    
    .section-title {
      font-size: 28px;
      margin-bottom: 30px;
    }
    
    .advantages, .solutions, .partners {
      padding: 40px 0;
    }
  }
}
</style> 